import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IPowerBiReport } from '../models/power-bi-report.model';
import { ApiService } from '../../../../core/services/api.service';

@Injectable({
    providedIn: 'root'
})
export class PowerBiApiService {
    private readonly resourceUrl = 'PowerBi/reports';

    constructor(private readonly apiService: ApiService) { }

    // New ID-based method for getting reports with embed tokens
    public getReportById(reportId: string): Observable<IPowerBiReport | null> {
        return this.apiService.get<IPowerBiReport | null>(`${this.resourceUrl}/${reportId}`);
    }
}
